import { apiGet, apiPatch } from './client';
import type {
  MutualFund,
  MutualFundBatchRequest,
  MutualFundCreate,
  MutualFundUpdate,
} from '../types/MutualFund';

export const getFunds = () => apiGet<MutualFund[]>('/api/funds');

export const getFund = (id: number) => apiGet<MutualFund>(`/api/funds/${id}`);

// Server expects tradingStartDate as "YYYY-MM-DD". AgGrid's date editor stores
// a Date object on the row, and JSON.stringify(Date) emits ISO with timezone —
// which can shift the calendar day. Normalize to local-calendar YYYY-MM-DD here.
function normalizeTradingStartDate(value: unknown): string | null {
  if (value == null) return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    const yyyy = value.getFullYear();
    const mm = String(value.getMonth() + 1).padStart(2, '0');
    const dd = String(value.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }
  if (typeof value === 'string') {
    return value.slice(0, 10);
  }
  return null;
}

function normalizeUpdate(fund: MutualFundUpdate): MutualFundUpdate {
  return {
    ...fund,
    tradingStartDate: normalizeTradingStartDate(fund.tradingStartDate),
  };
}

function normalizeCreate(fund: MutualFund): MutualFundCreate {
  const { fundId: _ignored, ...rest } = fund;
  return {
    ...rest,
    tradingStartDate: normalizeTradingStartDate(fund.tradingStartDate),
  };
}

export function saveBatchFunds(
  added: MutualFund[],
  modified: MutualFundUpdate[],
  deletedIds: number[],
): Promise<MutualFund[]> {
  const payload: MutualFundBatchRequest = {
    added: added.map(normalizeCreate),
    modified: modified.map(normalizeUpdate),
    deleted: deletedIds,
  };
  return apiPatch<MutualFundBatchRequest, MutualFund[]>('/api/funds/batch', payload);
}
